export const arrowLeft = [
  '24 24',
  `<polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/>`
]
